// Central content & config for Hülya Suna Beauty.
// Tüm görseller placeholder'dır ve gerçek salon fotoğraflarıyla kolayca değiştirilebilir.

export const BUSINESS = {
  name: "Hülya Suna Beauty",
  descriptor: "Güzellik • Kuaför • Türban Tasarım",
  slogan: "Sen Bir “Mucizesin”",
  phoneDisplay: "+90 505 831 90 95",
  phoneRaw: "+905058319095",
  whatsappNumber: "905058319095",
  instagram: "https://www.instagram.com/hulyasunabeauty/",
  instagramHandle: "@hulyasunabeauty",
  address: "Akabe Mahallesi, Şehit Furkan Doğan Caddesi No: 11/G, Karatay / Konya",
  addressShort: "Karatay / Konya",
  cityLabel: "KARATAY • KONYA",
  hours: [
    { day: "Pazartesi – Cuma", time: "08.00 – 19.00" },
    { day: "Cumartesi", time: "09.00 – 19.00" },
    { day: "Pazar", time: "Kapalı" },
  ],
};

// Google Maps yol tarifi linki — gerçek Google Business bağlantısıyla değiştirilebilir.
export const MAPS_DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
  "Hülya Suna Beauty, Akabe Mahallesi, Şehit Furkan Doğan Caddesi No: 11/G, Karatay Konya"
)}`;

export const MAPS_EMBED = `https://www.google.com/maps?q=${encodeURIComponent(
  "Akabe Mahallesi, Şehit Furkan Doğan Caddesi No: 11/G, Karatay Konya"
)}&output=embed`;

export const NAV = [
  { label: "Ana Sayfa", href: "#hero" },
  { label: "Hizmetler", href: "#hizmetler" },
  { label: "Gelin & Türban", href: "#gelin-turban" },
  { label: "Galeri", href: "#galeri" },
  { label: "Hakkımızda", href: "#hakkimizda" },
  { label: "İletişim", href: "#iletisim" },
];

const U = (id, w = 1200) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;
const P = (id, w = 1200) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=${w}`;

export const IMAGES = {
  heroPortrait: P("20194705"),
  heroSecondary: U("1563170446-9c3c0622d8a9"),
  salonInterior: P("33685861"),
  salonInterior2: U("1724582586529-62622e50c0b3"),
  bridal: P("29858712"),
  bridal2: U("1574871786514-46e1680ea587"),
  hair: U("1560066984-138dadb4c035"),
  hair2: U("1522337660859-02fbefca4702"),
  skin: U("1570172619644-dfd03ed5d881"),
  skin2: U("1512290923902-8a9f81dc236c"),
  nails: U("1604654894610-df63bc536371"),
  nails2: U("1607779097040-26e80aa78e66"),
  lashes: U("1583001931096-959e9a1a6223"),
  laser: U("1519824145371-296894a0daa9"),
};

// Hizmet kategorileri — magazine tarzı asimetrik yerleşim için "size" alanı taşır.
export const SERVICES = [
  {
    slug: "sac-kuafor",
    index: "01",
    title: "Saç & Kuaför",
    description:
      "Yüz hatlarınıza ve tarzınıza uygun saç kesimi, tasarımı ve renk çalışmaları. Günlük fönden özel gün saç tasarımına kadar bütünsel bir kuaför deneyimi.",
    items: ["Saç kesimi", "Saç tasarımı", "Fön", "Saç boyama", "Özel gün saç tasarımı"],
    image: IMAGES.hair,
    size: "large",
    alt: "Hülya Suna Beauty saç tasarımı ve kuaför uygulaması",
  },
  {
    slug: "gelin-turban",
    index: "02",
    title: "Gelin & Türban Tasarım",
    description:
      "Gelin saçı, türban tasarımı ve nişan hazırlığında kişiye özel görünüm planlaması. En özel gününüz için bütünsel bir konsept.",
    items: [
      "Gelin saçı",
      "Türban tasarımı",
      "Nişan ve özel gün hazırlığı",
      "Kişiye özel görünüm planlaması",
    ],
    image: IMAGES.bridal,
    size: "tall",
    alt: "Gelin ve türban tasarımı uygulaması",
  },
  {
    slug: "cilt-guzellik",
    index: "03",
    title: "Cilt & Güzellik",
    description:
      "Profesyonel cilt bakımı, Hydrafacial ve kalıcı makyaj uygulamalarıyla cildinize özenli bir dokunuş.",
    items: [
      "Hydrafacial",
      "Profesyonel cilt bakımı",
      "Kaş alımı",
      "Microblading",
      "Kalıcı makyaj",
    ],
    image: IMAGES.skin,
    size: "wide",
    alt: "Profesyonel cilt bakımı uygulaması",
  },
  {
    slug: "epilasyon",
    index: "04",
    title: "Epilasyon",
    description:
      "Lazer ve iğneli epilasyon uygulamalarıyla pürüzsüz ve bakımlı bir görünüm için profesyonel çözümler.",
    items: ["Lazer epilasyon", "İğneli epilasyon"],
    image: IMAGES.laser,
    size: "small",
    alt: "Lazer epilasyon uygulaması",
  },
  {
    slug: "kirpik-tirnak",
    index: "05",
    title: "Kirpik & Tırnak",
    description:
      "İpek kirpik, protez tırnak, kalıcı oje ve manikür-pedikür uygulamalarıyla detaylarda fark yaratan bir bakım.",
    items: ["İpek kirpik", "Protez tırnak", "Kalıcı oje", "Manikür", "Pedikür"],
    image: IMAGES.nails,
    size: "small",
    alt: "İpek kirpik ve tırnak uygulaması",
  },
];

export const BRIDAL_STEPS = [
  {
    no: "01",
    title: "Tanışma",
    text: "İhtiyaçlarınızı, tarzınızı ve özel gün konseptinizi birlikte konuşuyoruz.",
  },
  {
    no: "02",
    title: "Stil Planı",
    text: "Saç, makyaj ve türban tasarımını yüz hatlarınıza ve konseptinize göre planlıyoruz.",
  },
  {
    no: "03",
    title: "Hazırlık",
    text: "Belirlenen plana göre özenli ve zamanında bir hazırlık süreci yürütüyoruz.",
  },
  {
    no: "04",
    title: "Son Dokunuş",
    text: "En özel gününüzde kendinizi rahat ve özel hissetmeniz için son dokunuşları tamamlıyoruz.",
  },
];

export const GALLERY_FILTERS = [
  "Tümü",
  "Saç",
  "Kaş",
  "Kirpik",
  "Tırnak",
  "Cilt",
  "Gelin & Türban",
];

export const GALLERY_ITEMS = [
  { category: "Saç", image: IMAGES.hair2, label: "Saç tasarımı" },
  { category: "Gelin & Türban", image: IMAGES.bridal2, label: "Gelin & türban" },
  { category: "Cilt", image: IMAGES.skin2, label: "Cilt bakımı" },
  { category: "Tırnak", image: IMAGES.nails2, label: "Tırnak uygulaması" },
  { category: "Kirpik", image: IMAGES.lashes, label: "İpek kirpik" },
  { category: "Kaş", image: IMAGES.skin, label: "Kaş & microblading" },
  { category: "Saç", image: IMAGES.hair, label: "Fön & şekillendirme" },
  { category: "Gelin & Türban", image: IMAGES.bridal, label: "Türban tasarımı" },
];

export const INSTAGRAM_TILES = [
  IMAGES.hair2,
  IMAGES.bridal,
  IMAGES.skin2,
  IMAGES.nails,
  IMAGES.lashes,
  IMAGES.salonInterior,
];

export const FAQ = [
  {
    q: "Randevu nasıl oluşturabilirim?",
    a: "Randevunuzu WhatsApp üzerinden veya telefonla oluşturabilirsiniz. Sitedeki randevu formunu doldurduğunuzda bilgileriniz WhatsApp mesajı olarak hazırlanır; salon onayından sonra randevunuz kesinleşir.",
  },
  {
    q: "Randevusuz işlem yaptırabilir miyim?",
    a: "Yoğunluğa göre değişebildiği için en doğru bilgiyi telefonla veya WhatsApp üzerinden bizimle iletişime geçerek alabilirsiniz.",
  },
  {
    q: "Gelin ve türban tasarımı için ön görüşme gerekiyor mu?",
    a: "Özel gün hazırlıklarında görünümünüzü sizinle birlikte planlayabilmek için bir ön görüşme öneriyoruz. Detaylar için WhatsApp üzerinden yazabilirsiniz.",
  },
  {
    q: "İşlem süresi ne kadar?",
    a: "Süre, seçilen uygulamaya ve kişisel ihtiyaçlara göre değişir. Uygulamanıza özel tahmini süre için bizimle iletişime geçebilirsiniz.",
  },
  {
    q: "Hangi ödeme yöntemleri geçerli?",
    a: "Ödeme seçenekleriyle ilgili güncel bilgi için lütfen telefonla veya WhatsApp üzerinden bizimle iletişime geçin.",
  },
  {
    q: "Randevumu değiştirebilir miyim?",
    a: "Randevunuzu değiştirmek istediğinizde mümkün olan en kısa sürede WhatsApp üzerinden bize bildirmeniz yeterlidir.",
  },
];

export const TRUST = [
  "Kişiye Özel Uygulama",
  "Profesyonel Dokunuş",
  "Özenli ve Sıcak Deneyim",
];
